import React from 'react';
import { ThemeProvider as AmplifyThemeProvider, createTheme } from '@aws-amplify/ui-react';
import { useTheme } from './ThemeContext';

/*
 * Wraps Amplify's <Authenticator> so it follows TaskPogo's theme. The color
 * values map to the same CSS variables defined in src/styles/tokens.css —
 * meaning we don't need to maintain two palettes; Amplify reads from the
 * tokens via var(--tp-...) just like Bootstrap does.
 */
const tpTheme = createTheme({
  name: 'taskpogo',
  tokens: {
    colors: {
      background: {
        primary:   { value: 'var(--tp-surface)' },
        secondary: { value: 'var(--tp-surface-2)' },
        tertiary:  { value: 'var(--tp-bg)' },
      },
      font: {
        primary:   { value: 'var(--tp-text)' },
        secondary: { value: 'var(--tp-muted)' },
        interactive: { value: 'var(--tp-accent)' },
      },
      border: {
        primary:   { value: 'var(--tp-border)' },
        secondary: { value: 'var(--tp-border)' },
        focus:     { value: 'var(--tp-accent)' },
      },
      brand: {
        primary: {
          10:  { value: 'var(--tp-accent-soft)' },
          60:  { value: 'var(--tp-accent)' },
          80:  { value: 'var(--tp-accent-hover)' },
          100: { value: 'var(--tp-accent-hover)' },
        },
      },
    },
    radii: {
      small:  { value: 'var(--tp-radius-sm)' },
      medium: { value: 'var(--tp-radius-md)' },
      large:  { value: 'var(--tp-radius-lg)' },
    },
    fonts: {
      default: {
        variable: { value: "'Inter Variable', system-ui, sans-serif" },
        static:   { value: "'Inter Variable', system-ui, sans-serif" },
      },
    },
  },
});

export function AmplifyThemeBridge({ children }) {
  const { resolved } = useTheme();
  // colorMode tells Amplify which side of its dark-mode definitions to use.
  return (
    <AmplifyThemeProvider theme={tpTheme} colorMode={resolved}>
      {children}
    </AmplifyThemeProvider>
  );
}
